import axiosInstance from '../RestClient';

const BASE_URI = '/generatedDebts';

class GeneratedDebtService {
	async list() {
		const uri = `${BASE_URI}/`;
		const response = await axiosInstance.get(uri);
		return response;
	}
	async listFuture(query) {
		const uri = `${BASE_URI}/futureDues/search?${query}`;
		const response = await axiosInstance.get(uri);
		return response;
	}

	async create(payload) {
		const response = await axiosInstance.post(`${BASE_URI}/`, payload);
		return response;
	}
	async search(query) {
		const uri = `${BASE_URI}/search?${query}`;
		const response = await axiosInstance.get(uri);
		return response;
	}

	async applySurcharge(debtDueId, surchargeType, value) {
		const uri = `${BASE_URI}/${debtDueId}/applySurcharge`;
		const response = await axiosInstance.put(uri, { surchargeType, value });
		return response;
	}

	async getPendingCount() {
		const response = await axiosInstance.get(`${BASE_URI}/pendingCount`);
		return response;
	}

	async confirmCount(debtDueId, userCount) {
		const uri = `${BASE_URI}/${debtDueId}/confirmCount`;
		const response = await axiosInstance.put(uri, { userCount });
		return response;
	}

	async updateExpiration(debtDueId, expiration) {
		const uri = `${BASE_URI}/${debtDueId}/expiration`;
		const response = await axiosInstance.put(uri, { expiration });
		return response;
	}

}

export default new GeneratedDebtService();
